import React, { useEffect } from "react";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Redirect, Route, Switch } from "react-router-dom";
import { Home } from "./home";
import UncomfirmedAttendance from "./uncomfirmed-attendance";
import { connect } from "react-redux";
import {
	onClearSearch,
	// Info
	onHazardListRequest,
	onHazardousSubstanceListRequest,
	onStaffTrainingTopicListRequest,
	onJobSafetyAnalysisListRequest,
	onSafetyPlanChecklistListRequest,
	// Tasks
	onSafetyMinutesListRequest,
	onIncidentListRequest,
	onInductionMinutesListRequest,
	onStaffTrainingListRequest,
} from "features/health-and-safety/actions";
import { UNCOMFIRMED_ATTENDANCE_ROUTE } from "../home-actions";

const mapStateToProps = ({ featureFlags }) => ({
	featureFlags,
});

const mapDispatchToProps = {
	onClearSearch: onClearSearch,
	// Info
	onGetHazardsList: onHazardListRequest,
	onGetHazardousSubstanceList: onHazardousSubstanceListRequest,
	onGetStaffTrainingTopicList: onStaffTrainingTopicListRequest,
	onGetJobSafetyAnalysisList: onJobSafetyAnalysisListRequest,
	onGetSafetyPlanChecklistList: onSafetyPlanChecklistListRequest,
	// Tasks
	onGetSafetyMinutesList: onSafetyMinutesListRequest,
	onGetIncidentList: onIncidentListRequest,
	onGetInductionMinutesList: onInductionMinutesListRequest,
	onGetStaffTrainingList: onStaffTrainingListRequest,
};

export const HomeRoutes = connect(mapStateToProps, mapDispatchToProps)((props) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
	const staffTrainingEnabled = props.featureFlags?.staffTraining === true;
	useEffect(() => {
		props.onClearSearch();
		// Info
		props.onGetHazardsList();
		props.onGetHazardousSubstanceList();
		if (staffTrainingEnabled) {
			props.onGetStaffTrainingTopicList();
		}
		props.onGetJobSafetyAnalysisList();
		props.onGetSafetyPlanChecklistList();

		// Tasks
		props.onGetSafetyMinutesList();
		props.onGetIncidentList();
		props.onGetInductionMinutesList();
		if (staffTrainingEnabled) {
			props.onGetStaffTrainingList();
		}
	}, [props, staffTrainingEnabled]);

	return (
		<Switch>
		{/* home routes */}
		<Route exact path="/" component={Home} />
		<Route exact path="/home" component={Home} />
			<Route
				exact
				path={UNCOMFIRMED_ATTENDANCE_ROUTE}
				component={UncomfirmedAttendance}
			/>
			<Route>
				<Redirect to="/" />
			</Route>
		</Switch>
	);
});
